import React from 'react';
import { EntitySecurityProvider } from '../../../auth/Security';
import { useCurrentBreakpoint } from '../../../hooks/useCurrentBreakpoint';
import { MainSidePanelProps, SidePanelSx } from '../LayoutUtils';
import SidePanelContent from './SidePanelContent';

const SIDE_PANEL_WIDTH = '395px';
const SIDE_PANEL_EXPANDED = '40vw';

const SIDE_PANEL_SX = (expandView: boolean): SidePanelSx => {
    const size = expandView ? SIDE_PANEL_EXPANDED : SIDE_PANEL_WIDTH;

    return {
        xs: {
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 1
        },
        s: {
            display: 'flex',
            height: '100%',
            width: '100%',
            zIndex: 1
        },
        m: {
            display: 'flex',
            height: '100%',
            width: size,
            minWidth: size,
            maxWidth: size,
            zIndex: 1
        },
        l: {
            display: 'flex',
            height: '100%',
            width: size,
            minWidth: size,
            maxWidth: size,
            zIndex: 1
        },
        xl: {
            display: 'flex',
            height: '100%',
            width: size,
            minWidth: size,
            maxWidth: size,
            zIndex: 1
        }
    };
};

export const useSidePanelSx = (expandView: boolean) => {
    const breakpoint = useCurrentBreakpoint();
    return SIDE_PANEL_SX(expandView)[breakpoint];
};

/**
 * @deprecated Migrate to the Centralized Side-Panel System. See
 * `packages/ui-main/docs/CENTRALIZED_SIDE_PANEL_SYSTEM_DESIGN.md`.
 */
export default function WithSidePanel({ entitySecurityProviderProps, ...sidePanelContentProps }: MainSidePanelProps) {
    if (entitySecurityProviderProps) {
        return (
            <EntitySecurityProvider {...entitySecurityProviderProps}>
                <SidePanelContent {...sidePanelContentProps} />
            </EntitySecurityProvider>
        );
    }

    return <SidePanelContent {...sidePanelContentProps} />;
}
